<template>
  <b-form-group :state="state">
    <b-form-tags
      v-model="tags"
      input-id="tags-remove-on-delete"
      :input-attrs="{ 'aria-describedby': 'tags-remove-on-delete-help' }"
      :class="{ 'is-invalid': !state }"
      :separator="separator"
      :placeholder="placeholder"
      remove-on-delete
      no-add-on-enter
      tag-pills
      class="rounded-lg"
      :tag-variant="variant"
      :add-button-variant="addVariant"
      :tag-validator="tagValidator"
      :add-button-text="addButtonText"
      :invalid-tag-text="invalidTagText"
      :duplicate-tag-text="duplicateTagText"
      @input="onInput"
    />
    <template v-slot:invalid-feedback>
      <slot name="invalid-feedback" />
    </template>
  </b-form-group>
</template>

<script>
export default {
  props: {
    separator: {
      type: String,
      default: ' '
    },
    placeholder: {
      type: String
    },
    variant: {
      type: String,
      default: 'primary'
    },
    addVariant: {
      type: String,
      default: 'outline-primary'
    },
    addButtonText: {
      type: String,
      default: 'Add'
    },
    tagValidator: {
      type: Function,
      default: () => true
    },
    validator: {
      type: Function,
      default: () => true
    },
    invalidTagText: {
      type: String,
      default: 'invalid tag'
    },
    duplicateTagText: {
      type: String,
      default: 'duplicate tag'
    },
  },
  data() {
    return {
      tags: [],
      newTag: '',
      dirty: false,
    };
  },
  computed: {
    state() {
      return this.dirty ? this.validator(this.tags) : true;
    }
  },
  methods: {
    initialize() {
      this.tags = [];
      this.dirty = false;
    },
    onInput() {
      this.dirty = true;
      this.$emit('change', this.tags);
    },
    validate() {
      this.dirty = true;
      return this.state;
    }
  }
};
</script>
